<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>For their endless encouragement and steadfast contributions to this work of ‘Art &amp; Behavioral Science’, the author wishes to thank:</p><br/>
<p style="text-indent:0em">Mary Ann McDonald-Palmer &amp; Glen Palmer</p>
<p style="text-indent:0em">Mabel and Gertrude Collins</p>
<p style="text-indent:0em">Atoil Smith</p>
<p style="text-indent:0em">Hugh Douglas McDonald VI</p>
<p style="text-indent:0em">Reva O’Neal-McDonald &amp; Hugh Douglas McDonald VII</p>
<p style="text-indent:0em">Bertha O’Neal-Hankins</p>
<p style="text-indent:0em">Shirley Davis-Moles &amp; Armand Moles</p>
<p style="text-indent:0em">Mark Moles</p>
<p style="text-indent:0em">Steve Moles</p>
<p style="text-indent:0em">Lisa Moles-Doak</p>
<p style="text-indent:0em">Lori Moles-Wallace</p>
<p style="text-indent:0em">Patsy McDonald-Johnson &amp; Richard Johnson</p>
<p style="text-indent:0em">Christie Johnson-Smith</p>
<p style="text-indent:0em">Douglas Johnson</p>
<p style="text-indent:0em">Yoseph Geshiri, Ph.D.</p>
<p style="text-indent:0em">Lawrence Riley, Ed.D.</p>
<p style="text-indent:0em">Anthony Buhl, Ph.D.</p>
<p style="text-indent:0em">Dorothy Moore, Ph.D.</p>
<p style="text-indent:0em">Robert Mather, M.A.</p>
<p style="text-indent:0em">Edward Gray</p>
<p style="text-indent:0em">Rev. John Swisher</p>
<p style="text-indent:0em">Nina Bolling, M.A., L.P.C.</p>
<p style="text-indent:0em">Ken Thom, M.S., L.P.C.</p>
<p style="text-indent:0em">Authorene Phillips</p>
<p style="text-indent:0em">All the members of the Marshall Missouri Writers Guild</p>
<p style="text-indent:0em">The Marshall Missouri Public Library staff</p>
<p style="text-indent:0em">The Missouri State Historical Society</p>
<p style="text-indent:0em">The Hon. John Andrews</p>
<p style="text-indent:0em">The Hon. James T. Bellamy</p>
<p style="text-indent:0em">Ann Covington, Chief Justice of the Missouri Supreme Court (Ret.)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?1328da94